import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getTypeList = store => store[NAME].typeList;
export const getScaleList = store => store[NAME].scaleList;
export const getTransversalSkillsList = store => store[NAME].transversalSkillsList;
export const getEvaluationGroupsList = store => store[NAME].evaluationGroupsList;